import React, { Component } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { BiSearch } from "react-icons/bi";
import { Modal, ModalBody } from "reactstrap";
import { cities, states } from "../../../../base/services/services";
import { MdClose } from "react-icons/md";
import Empty from "../../../../base/features/blocks/Empty";
import Swal from "sweetalert2";

class CityModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      states: null,
      cities: null,
      key: "",
      selectedState: null,
    };
  }
  componentDidMount() {
    this.getStates();
  }
  getStates() {
    states().then((items) => {
      items &&
        this.setState({
          states: items,
        });
    });
  }
  getCities() {
    this.state.selectedState &&
      this.state.selectedState.uid &&
      cities(this.state.selectedState.uid).then((items) => {
        items &&
          this.setState({
            cities: items,
          });
      });
  }

  render() {
    return (
      <div>
        {this.state.selectedState && !this.state.cities && this.getCities()}
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          backdropClassName="saeed"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto max-h-75 h-75"
          isOpen={this.props.geoModal}
          toggle={() => this.props.changeModal(!this.props.geoModal)}
        >
          <ModalBody className="row mx-0 p-4" style={{ flex: "unset" }}>
            <div className="col-12 px-0">
              <h2 className="fs-5 fw-bold mb-3">
                {this.state.selectedState ? (
                  <span
                    onClick={() => {
                      this.setState({ cities: null, selectedState: null });
                    }}
                  >
                    <FiChevronRight className="ms-2" size={22} />
                    شهر
                  </span>
                ) : (
                  "استان"
                )}
              </h2>
              <div className="row mx-0 p-3 rounded14 border mb-4">
                <div className="col-auto px-0">
                  <BiSearch size={22} className="text-secondary" />
                </div>
                <div className="col px-2">
                  <input
                    className="w-100 h-100 p-0 border-0 fw-bold border-0"
                    placeholder="جستجو ..."
                    value={this.state.key}
                    onChange={(e) => this.setState({ key: e.target.value })}
                  />
                </div>
                {this.state.key && (
                  <div className="col-auto px-0">
                    <MdClose
                      size={26}
                      onClick={() => this.setState({ key: "" })}
                    />
                  </div>
                )}
              </div>
            </div>
            {this.state.states &&
              !this.state.cities &&
              (this.state.states.filter((person) =>
                person.name.includes(this.state.key)
              ).length === 0 ? (
                <Empty />
              ) : (
                this.state.states
                  .filter((person) => person.name.includes(this.state.key))
                  .map((state, s) => (
                    <div
                      onClick={() => {
                        this.setState({ key: "", selectedState: state });
                      }}
                      className="col-12 p-3 mt-2 rounded14 border d-flex justify-content-between"
                    >
                      <span className="fw-bold">{state.name}</span>
                      <FiChevronLeft size={25} />
                    </div>
                  ))
              ))}
            {this.state.cities &&
              (this.state.cities.filter((person) =>
                person.name.includes(this.state.key)
              ).length === 0 ? (
                <Empty />
              ) : (
                this.state.cities
                  .filter((person) => person.name.includes(this.state.key))
                  .map((state, s) => (
                    <div
                      onClick={() => {
                        if (this.props.selectedCities.length === 0) {
                          this.props.setCity(state);
                          this.setState({ selectedState: null });
                          this.props.changeModal(!this.props.geoModal);
                        } else {
                          var add = true;
                          this.props.selectedCities.map((selectedCity, s) => {
                            if (selectedCity.uid === state.uid) {
                              add = false;
                              Swal.fire({
                                text: "این شهر در لیست موجود است",
                                showConfirmButton: false,
                                position: "bottom",
                                toast: true,
                                customClass: {
                                  htmlContainer: "text-center m-0",
                                },
                                timer: 2000,
                                width: 230,
                                timerProgressBar: true,
                              });
                            }
                          });
                          if (add) {
                            this.props.setCity(state);
                            this.setState({ selectedState: null });
                            this.props.changeModal(!this.props.geoModal);
                          }
                        }
                      }}
                      className="col-12 p-3 mt-2 rounded14 border d-flex justify-content-between"
                    >
                      <span className="fw-bold">{state.name}</span>
                      <FiChevronLeft size={25} />
                    </div>
                  ))
              ))}
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default CityModal;
